import { useTranslation } from 'react-i18next';
import {
  Icon,
  BaseModal,
  BaseModalProps,
  SocialButton,
  SocialLinkedAccounts,
  SocialLinkedAccountsProps
} from '@anytag/shared-atoms';
import { checkIconImage } from '@anytag/shared-assets';
import { SupportedSocialMediaType } from '@anytag/shared-types';

export interface SocialReconnectModalProps extends BaseModalProps {
  reconnected?: boolean;
  reconnecting?: boolean;
  onReconnect?: () => void;
  accounts?: SocialLinkedAccountsProps['accounts'];
  socialMedia?: keyof typeof SupportedSocialMediaType;
}

export const SocialReconnectModal = ({
  onClose,
  reconnected,
  onReconnect,
  socialMedia,
  reconnecting,
  accounts = [],
  ...restProps
}: SocialReconnectModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      onClose={onClose}
      title={
        !reconnected ? (
          <div className="flex items-center gap-2">
            <Icon size={20} icon="warning" variant="yellow" />
            {t('Dialog.Please reconnect account')}
          </div>
        ) : (
          t('Dialog.Successfully connected')
        )
      }
      description={!reconnected ? t('PleaseReconnectYourAccount') : null}
      footer={
        !reconnected
          ? { cancelButton: { title: t('Button.Cancel'), onClick: onClose } }
          : { submitButton: { title: t('Button.Save'), onClick: onClose } }
      }
      {...restProps}
    >
      <div className="flex min-w-100 rounded-md border-base-border bg-white p-4">
        <SocialLinkedAccounts accounts={accounts} />

        {!reconnected && socialMedia && onReconnect ? (
          <SocialButton
            onClick={onReconnect}
            socialMedia={socialMedia}
            title={t('Button.Reconnect')}
            loading={{ status: reconnecting, showIcon: true }}
            className="ml-auto px-4 uppercase"
          />
        ) : (
          <img alt="" src={checkIconImage} className="ml-auto" />
        )}
      </div>
    </BaseModal>
  );
};
